// extracted by mini-css-extract-plugin
export default {"card":"ChatListCardSkeleton_card__gUxdA"};